import NameLinkCell from '@/components/NameLinkCell';
import { Stack } from '@nautilusbio/nb-design-system/Stack';
import { Text } from '@nautilusbio/nb-design-system/Text';
import { Tooltip } from '@nautilusbio/nb-design-system/Tooltip';
import React from 'react';
import type { FC } from 'react';

import styles from './styles.module.css';

export type OrgCellProps = {
  orgIds: string[];
  orgNameMap: Map<string, string>;
};

// POR-282: every org name (including each entry in the multi-org tooltip) links out to that org's own detail page.
const OrgLink: FC<{ id: string; name: string }> = ({ id, name }) => (
  <NameLinkCell
    className={styles.nameBtn}
    id={id}
    name={name}
    params={{ orgId: id }}
    testId={`org-link-${id}`}
    to="/organizations/$orgId"
  />
);

const OrgCell: FC<OrgCellProps> = ({ orgIds, orgNameMap }) => {
  const names = orgIds.map(id => orgNameMap.get(id) ?? id);

  if (names.length === 0) return <Text as="span">—</Text>;
  if (names.length === 1) return <OrgLink id={orgIds[0]} name={names[0]} />;

  return (
    <Tooltip
      content={
        <Stack gap={2} orientation="vertical">
          {orgIds.map((id, i) => (
            <OrgLink id={id} key={id} name={names[i]} />
          ))}
        </Stack>
      }
      placement="bottom"
      trigger={
        <Text as="span">
          {names[0]} +{names.length - 1}
        </Text>
      }
      triggerProps={{ tabIndex: 0 }}
    />
  );
};

export default OrgCell;
